export const conditionFragment = `... on Condition {
  conditionName
  conditionValue
  shouldMatch
}`;
